export default __webpack_public_path__ + "static/7-37a9b280eb99035f244a238d45c1cff7.webp";